'use client';

import { useEffect } from 'react';

import { preloadModals } from '../store/modal-store';
import { preloadSheets } from '../store/sheet-store';

/**
 * A client component that triggers the preloading of all registered modals
 * in the background on initial mount.
 */
const Preloader = (): null => {
  useEffect(() => {
    // Run only once on the client after initial render
    preloadModals();
    preloadSheets();
  }, []);

  // This component doesn't render anything itself
  return null;
};

export default Preloader;
